import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {map, Observable } from 'rxjs';
import {AppState} from "../store/store";
import {Store} from "@ngrx/store";
import {selectInitIsLoaded} from "../store/init/init.selectors";
import {tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionGuard implements CanActivate {

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._store.select(selectInitIsLoaded)
      .pipe(
        tap((loaded: boolean): void => {
          if (!loaded) {
            this._router.navigate(['/']);
          }
        }),
      )
  }

}
